import type { ServiceResponse } from "../core/service";
import type {
  GetConfigChainsResponse,
  GetConfigTokensRequestParameters,
  GetConfigTokensResponse,
  GetDelegateAddressRequest,
  GetDelegateAddressResponse,
  GetHealthResponse,
  GetInstructionStorageAddressRequest,
  GetInstructionStorageAddressResponse,
} from "../schemas/config";

import { BaseService } from "../core/service";
import {
  getConfigChainsResponseSchema,
  getConfigTokensResponseSchema,
  getDelegateAddressResponseSchema,
  getHealthResponseSchema,
  getInstructionStorageAddressResponseSchema,
} from "../schemas/config";

export class ConfigService extends BaseService {
  public async getDelegateAddress(
    params: GetDelegateAddressRequest,
  ): Promise<ServiceResponse<GetDelegateAddressResponse>> {
    return this.get(`/config/delegate/address/${params.chainId}`, {
      responseSchema: getDelegateAddressResponseSchema,
    });
  }

  public async getTokens(
    params: GetConfigTokensRequestParameters,
  ): Promise<ServiceResponse<GetConfigTokensResponse>> {
    return this.get(`/config/tokens/${params.chainId}`, {
      responseSchema: getConfigTokensResponseSchema,
    });
  }

  public async getChains(): Promise<ServiceResponse<GetConfigChainsResponse>> {
    return this.get(`/config/chains`, {
      responseSchema: getConfigChainsResponseSchema,
    });
  }

  public async getInstructionStorageAddress(
    params: GetInstructionStorageAddressRequest,
  ): Promise<ServiceResponse<GetInstructionStorageAddressResponse>> {
    return this.get(`/config/instruction/storage/address/${params.chainId}`, {
      responseSchema: getInstructionStorageAddressResponseSchema,
    });
  }

  public async getHealth(): Promise<ServiceResponse<GetHealthResponse>> {
    return this.get("/health", {
      responseSchema: getHealthResponseSchema,
    });
  }
}
